import type {PageRouteConfig} from '@router';

import TicketDetails from 'modules/Ticket/TicketDetails/TicketDetails';
import {routes} from 'routes/routes';
import {sanitizeRedirect} from 'utils/Helper';

export function createTicketDetailsRoute(): PageRouteConfig {
  return {
    element: <TicketDetails />,
    layout: {
      title: 'جزئیات درخواست',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      resolveLink: (ctx) => {
        const currentQuery = new URLSearchParams(ctx.location?.search);
        const ticketsUrl = new URLSearchParams();

        for (const key of ['order_code', 'type', 'state']) {
          const value = currentQuery.get(key);
          if (value) ticketsUrl.set(key, value);
        }

        const from = currentQuery.get('from');
        if (from) {
          ticketsUrl.set('from', sanitizeRedirect(from, routes.TICKETS));
        }

        const search = ticketsUrl.toString();
        return search ? `${routes.TICKETS}?${search}` : routes.TICKETS;
      }
    }
  };
}
